export const normalizeUrl = (url: string) => {
  if (url.startsWith('https://') || url.startsWith('http://')) {
    return url;
  }

  if (url.startsWith('/')) {
    return `${window.location.origin}${url}`;
  }

  if (url.startsWith('//')) {
    return `https:${url}`;
  }

  return `https://${url}`;
};
